/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { ROUTES } from './router_config_loader';
import { ROUTER_PROVIDERS } from './router_module';
import { flatten } from './utils/collection';
export var /** @type {?} */ __router_private__ = {
    ROUTER_PROVIDERS: ROUTER_PROVIDERS,
    ROUTES: ROUTES,
    flatten: flatten,
};
//# sourceMappingURL=private_export.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/router/src/private_export.js
// module id = 759
// module chunks = 3